import * as moment from 'moment';

export class DateUtils {
  static toStrYYYYMMDD(dateValue): string {
    if (!dateValue) {
      return '';
    }
    let result = moment(dateValue).format('YYYY-MM-DD');
    return result;
  }
  static toStrYYYY(dateValue): string {
    if (!dateValue) {
      return '';
    }
    return moment(dateValue).format('YYYY');
  }
  static toStrMM(dateValue): string {
    if (!dateValue) {
      return '';
    }
    return moment(dateValue).format('MM');
  }
  static toStrDD(dateValue): string {
    if (!dateValue) {
      return '';
    }
    return moment(dateValue).format('DD');
  }


  static toDateTimeStr(dateValue: Date): string {
    if (!dateValue) {
      return null;
    }
    return moment(dateValue).format('YYYY-MM-DD HH:mm:ss');
  }

  static toDateYYYYMMDD(dateValue): Date {
    if (!dateValue) {
      return null;
    }
    return moment(moment(dateValue).format('YYYYMMDD')).toDate();
  }
  static getNowYYMMDDHHmmSS() {
    return moment().format('YYYYMMDDHHmmss');
  }
  static getCurrentDate() {
    return moment(moment().format('YYYY-MM-DD')).toDate();
  }
}
